module.exports = __webpack_public_path__ + "static/media/search-icon.80e9d8a2.svg";